export class RubricStatusVO{
    public videobric_adaptive: string;
    public iconclick_adaptive: string;
    public clicktoreveal_adaptive: string;
    public hotspot_adaptive: string;
    public threescreen_adaptive: string;
    public scenario_multichoice_adaptive: string;
    constructor(){
        this.videobric_adaptive = "n";
        this.iconclick_adaptive = "n";
        this.clicktoreveal_adaptive = "n";
        this.hotspot_adaptive = "n";
        this.threescreen_adaptive = "n";
        this.scenario_multichoice_adaptive = "n";
    }
}